import { useTranslator } from '@bluebeam/react-i18n';
import BouncingSpinner from 'components/BouncingSpinner';
import Download from 'components/Icons/Download';
import { Button } from 'components/lib';
import React, { useState } from 'react';
import { Project } from 'records/Project';
import { RFI } from 'records/RFI';
import { getRFIReport } from 'services/rfiService';
import { downloadFileWithAnchor } from 'utils/general';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps {
  rfi: RFI;
}

const DownloadRFI = (props: Props): React.ReactElement => {
  const { translate } = useTranslator(['mapView']);
  const [downloading, setDownloading] = useState(false);

  const handleDownloadClick = async (): Promise<void> => {
    const { appState, rfi } = props;
    const { projects, selectedProject } = appState;
    const project = projects.get(selectedProject, new Project());
    setDownloading(true);

    const url = await getRFIReport(appState.selectedProject, rfi.id);

    const date = new Date();
    const dateString = `${
      date.getMonth() + 1
    }.${date.getDate()}.${date.getFullYear()}`;
    // RFI number - RFI title - Project name - date
    const filename = `${translate('mapView:postRFIListItem.rfi')} ${
      rfi.number
    } - ${rfi.title} - ${project.name} - ${dateString}.pdf`;

    await downloadFileWithAnchor(url, filename);

    setDownloading(false);
  };

  return (
    <div>
      {downloading ? (
        <div className="flex-center mt1 ml3">
          <BouncingSpinner />
        </div>
      ) : (
        <Button
          size="large"
          id="rfi-download-item"
          variant="tertiary"
          className="row items-center justify-between mr2"
          onClick={handleDownloadClick}
        >
          <div className="mr2 fill-primary">
            <Download width="14px" height="12px" />
          </div>
          <div className="font-size-4">
            {translate('mapView:downloadRFI.download')}
          </div>
        </Button>
      )}
    </div>
  );
};

export default withAppStore<Props>(DownloadRFI);
